import { render, staticRenderFns } from "./ArtistList.vue?vue&type=template&id=480760ae&scoped=true"
import script from "./ArtistList.vue?vue&type=script&lang=ts"
export * from "./ArtistList.vue?vue&type=script&lang=ts"
import style0 from "./ArtistList.vue?vue&type=style&index=0&id=480760ae&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480760ae",
  null
  
)

export default component.exports